// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__2yBC4","footer":"ReportModalFilter_footer__2XYU1"};